import React, { useState, useEffect } from "react";
import "../Style.css"; import "../Responsive.css";
import "../bootstrap.min.css";
import { loadProductsFromServer } from "../core/serviceClient";
import { Box, Container, Stack } from "@mui/system";
import Utils from "../core/Utils";
import UserHelper from "../core/UserHelper";
import { BelowThresholdPage, LoginPage } from "../core/PageConstants";
import { useNavigate } from "react-router-dom";
import { Button, Card, Grid, Typography } from "@mui/material";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import { SideBarMenuNames } from "../core/Constants";
import { OverviewPage } from "../core/PageConstants";
import "../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useDispatch } from "react-redux";
import { getCountry } from "../data/localSettingsActions";
import { Label } from "@mui/icons-material";

const BelowThreshold = () => {
    document.title = "BelowThreshold";
    var pageTitle = "Below Threshold";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);


    useEffect(() => {
        if (UserHelper.CheckPermission(BelowThresholdPage, navigate)) {
            getBelowThresholdProducts();
        }
    }, []);

    const getBelowThresholdProducts = async () => {
        setIsLoading(true);
        var result = await loadProductsFromServer();
        setIsNavigateToLogin(result.isNavigateToLogin);
        if (result.error) {
            setMsgOpen(true);
            setMsgText(result.errorMessage);
        }
        var data = result.data;
        if (!Utils.IsNullOrEmptyArray(data)) {
            data = data.filter(
                (c) =>
                    c.service === false && c.isMaterial === false && c.threshold > c.onHandQuantity
            );
        }
        setProducts(data);
        setIsLoading(false);
    }
    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const backNavigation = () => {
        navigate(OverviewPage.Path, {});
    };
    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid xs={12} className="content-sec" sx={{ "padding-bottom": "100px" }}>
                            <Grid container direction="row" className="">
                                <Grid
                                    flex="1"
                                    spacing={2}
                                    className="form-sec p-0"
                                >
                                    <Grid container className="title-sec">
                                        <Typography
                                            level="h2"
                                            component="h2"
                                            fontWeight="600"
                                            fontSize="2rem"
                                            className="page-title text-center"
                                        >
                                            <Button onClick={backNavigation} className="back-btn">
                                                <NavigateBeforeIcon />
                                            </Button>
                                            {pageTitle}
                                        </Typography>
                                    </Grid>
                                    <Grid container xs={12} className="font-size-14 data-grid-box">
                                        <Box sx={{ width: "100%" }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    px: 2,
                                                    py: 1,
                                                    backgroundColor: "#f5f5f5",
                                                    fontWeight: "bold",
                                                    borderBottom: "2px solid #ccc",
                                                    borderRadius: 1,
                                                }}
                                            >
                                                <Typography sx={{ width: "33.33%" }}>Name</Typography>
                                                <Typography sx={{ width: "33.33%" }}>On Hand</Typography>
                                                <Typography sx={{ width: "33.33%", textAlign: "right" }}>Price</Typography>
                                            </Box>

                                            {products.map((product, index) => (
                                                <Card
                                                    key={index}
                                                    sx={{
                                                        width: "100%",
                                                        mt: 1,
                                                        px: 2,
                                                        py: 1.5,
                                                        boxShadow: 2,
                                                        borderRadius: 2,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Typography sx={{ width: "33.33%" }}>{product.shortDesc}</Typography>
                                                        <Typography sx={{ width: "33.33%" }}>{product.onHandQuantity}</Typography>
                                                        <Typography sx={{ width: "33.33%", textAlign: "right" }}>
                                                            {Utils.GetCurrency(product.price, getCountry(), 2)}
                                                        </Typography>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    )
}
export default BelowThreshold;